var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfFrenchGuiana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_18613)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H0V45H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H40.0031V45H60V0Z",
    fill: "#002654"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9971 0H0.000196457V45H19.9971V0Z",
    fill: "#CE1126"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_18613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfFrenchGuiana);
export default __webpack_public_path__ + "static/media/gf French Guiana.0b45b4fe1b0986cbb4015f41c74ff4bf.svg";
export { ForwardRef as ReactComponent };